import { ConstantsPage } from '../ConstantsPage';

export function Constants302() {
  return <ConstantsPage version="3.0.2" />;
}
